import { Link } from "@remix-run/react";
import DemoNavigation from "~/components/DemoNavigation";
const navigation = [
	{ name: 'Product', href: '#' },
	{ name: 'Features', href: '#' },
	{ name: 'Resources', href: '#' },
	{ name: 'Company', href: '#' },
]
export default function Contact() {
	return (
		<div className="bg-white h-full">
			{/* Header */}
			<header className="absolute inset-x-0 top-0 z-50">
				<DemoNavigation />
			</header>

			<main className="isolate">
				{/* Hero section */}
				<div className="relative isolate -z-10 h-full">
					<div className="relative isolate bg-white px-6 py-24 sm:py-32 lg:px-8 lg:pt-64">
						<svg
							aria-hidden="true"
							className="absolute inset-0 -z-10 h-full w-full stroke-gray-200 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]"
						>
							<defs>
								<pattern
									x="50%"
									y={-64}
									id="83fd4e5a-9d52-42fc-97b6-718e5d7ee527"
									width={200}
									height={200}
									patternUnits="userSpaceOnUse"
								>
									<path d="M100 200V.5M.5 .5H200" fill="none" />
								</pattern>
							</defs>
							<svg x="50%" y={-64} className="overflow-visible fill-gray-50">
								<path
									d="M-100.5 0h201v201h-201Z M699.5 0h201v201h-201Z M499.5 400h201v201h-201Z M299.5 800h201v201h-201Z"
									strokeWidth={0}
								/>
							</svg>
							<rect fill="url(#83fd4e5a-9d52-42fc-97b6-718e5d7ee527)" width="100%" height="100%" strokeWidth={0} />
						</svg>
						<div className="mx-auto max-w-xl lg:max-w-4xl">
							<h2 className="text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
								Need help? Contact us.
							</h2>
							<p className="mt-2 text-lg/8 text-gray-600">
								Before emailing, please read <a className="text-binz-blue underline" href="#">FAQ’s</a> as they will likely answer your questions.
							</p>
							<div className="mt-16 flex flex-col gap-16 sm:gap-y-20 lg:flex-row">
								<form action="#" method="POST" className="lg:flex-auto">
									<div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
										<div>
											<label htmlFor="first-name" className="block text-sm/6 font-semibold text-gray-900">
												First name
											</label>
											<div className="mt-2.5">
												<input
													id="first-name"
													name="first-name"
													type="text"
													autoComplete="given-name"
													className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-binz-blue sm:text-sm/6"
												/>
											</div>
										</div>
										<div>
											<label htmlFor="last-name" className="block text-sm/6 font-semibold text-gray-900">
												Last name
											</label>
											<div className="mt-2.5">
												<input
													id="last-name"
													name="last-name"
													type="text"
													autoComplete="family-name"
													className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-binz-blue sm:text-sm/6"
												/>
											</div>
										</div>
										<div className="sm:col-span-2">
											<label htmlFor="message" className="block text-sm/6 font-semibold text-gray-900">
												Message
											</label>
											<div className="mt-2.5">
												<textarea
													id="message"
													name="message"
													rows={4}
													className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-binz-blue sm:text-sm/6"
													defaultValue={''}
												/>
											</div>
										</div>
									</div>
									<div className="mt-10">
										<button
											type="submit"
											className="block w-full rounded-md bg-binz-blue px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-binz-blue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-binz-blue"
										>
											Let’s talk
										</button>
									</div>
									<p className="mt-4 text-sm/6 text-gray-500">
										By submitting this form, I agree to the{' '}
										<Link to="/privacy" className="font-semibold text-binz-blue">
											privacy&nbsp;policy
										</Link>
										.
									</p>
								</form>
								<div className="lg:mt-6 lg:w-80 lg:flex-none">
									<img
										alt=""
										src="https://tailwindui.com/plus/img/logos/workcation-logo-binz-blue.svg"
										className="h-12 w-auto"
									/>
									<figure className="mt-10">
										<blockquote className="text-lg/8 font-semibold text-gray-900">
											<p>
												“LWe started to use Binz last year and I can't believe how easy it is to use and also the service is unbelievable. I highly recommend Binz to anyone who travel regularly to Cabo as you get to leave so much stuff behind and not have to transport it back and forth each flight. A great experience and will continue to use them until my travel days are over.
												Thanks to Terry and her team for their support with everything.
											</p>
										</blockquote>
										<figcaption className="mt-10 flex gap-x-6">
											<div>
												<div className="text-base font-semibold text-gray-900">Bill B</div>
											</div>
										</figcaption>
									</figure>
								</div>
							</div>
						</div>
					</div>
				</div>
			</main>

			{/* Footer */}
			<footer className="mt-16 sm:mt-32">
				<div className="mx-auto max-w-7xl overflow-hidden px-6 py-20 sm:py-24 lg:px-8">
					<nav aria-label="Footer" className="-mb-6 flex flex-wrap justify-center gap-x-12 gap-y-3 text-sm/6">
						{navigation.map((item) => (
							<a key={item.name} href={item.href} className="text-gray-600 hover:text-gray-900">
								{item.name}
							</a>
						))}
					</nav>
					<p className="mt-10 text-center text-sm/6 text-gray-600">
						&copy; 2024 Your Company, Inc. All rights reserved.
					</p>
				</div>
			</footer>
		</div>
	)
}
